import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { FrecuenciaDistribuidorCreationContent } from './components/FrecuenciaDistribuidorCreationContent';

export default function FrecuenciaDistribuidorCreation() {
    return (
        <MainContent
            component={<FrecuenciaDistribuidorCreationContent />}
            titulo='Frecuencia Distribucion'
        />
    );

};
